module.exports = __webpack_public_path__ + "img/maintenance.f152d85b.svg";